import { useState } from "react";
import { toast } from "sonner";
import { BookHeart, Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { AlertToggleCard } from "@/components/LoginAlertsCard";

export const MonthlyStoryCard = () => {
  const [sending, setSending] = useState(false);
  const send = async () => {
    setSending(true);
    try { const { data } = await api.post("/monthly-story/send-test"); toast.success(data.message); }
    catch (e) { toast.error(errMsg(e, "Could not send your story")); }
    finally { setSending(false); }
  };
  return (
    <AlertToggleCard field="monthly_story_enabled" icon={BookHeart} title="Monthly emotion story" label="Monthly emotion story" testid="monthly-story"
      desc="On the 1st at 9am, an email with last month's top emotions, how they changed, your toughest and brightest days and the skill that helped most.">
      <button onClick={send} disabled={sending} className="mm-btn-ghost !py-1.5 !px-3 text-sm inline-flex items-center gap-1.5 mt-4" data-testid="monthly-story-send-preview">
        {sending && <Loader2 size={14} className="animate-spin" />} Send a preview now
      </button>
    </AlertToggleCard>
  );
};
